"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMEZONE_MAP = void 0;
// mapping from timezones returned by geo-tz to timezones expected by Intl
exports.TIMEZONE_MAP = {
    "America/Argentina/Buenos_Aires": "America/Buenos_Aires",
    "America/Argentina/Mendoza": "America/Mendoza",
    "America/Argentina/Cordoba": "America/Cordoba",
    "America/Argentina/Jujuy": "America/Jujuy",
    "America/Argentina/Catamarca": "America/Catamarca",
    "America/Atikokan": "America/Panama",
    "America/Indiana/Indianapolis": "America/Indianapolis",
    "America/Kentucky/Louisville": "America/Louisville",
    "Asia/Kolkata": "Asia/Calcutta",
    "Asia/Ho_Chi_Minh": "Asia/Saigon",
    "Asia/Yangon": "Asia/Rangoon",
    "Asia/Kathmandu": "Asia/Katmandu",
    "Pacific/Chuuk": "Pacific/Port_Moresby",
    "Pacific/Pohnpei": "Pacific/Guadalcanal",
    "Atlantic/Faroe": "Atlantic/Faeroe",
};
//# sourceMappingURL=timezones.js.map